import { useGetActiveLeadSourceDetails } from '../../hooks'
import { useCampaignPhoneNumberCountStore } from '@forwardflow/store/campaignPhoneNumberCountStore'
import Icon from '@forwardflow/ui/Icons'
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom'

export const NavigationBar = () => {
   const location = useLocation()
   const [searchParams] = useSearchParams()
   const campaignName = searchParams.get('campaignName')
   const { title } = useParams()
   const { data: LeadSourceDetails } = useGetActiveLeadSourceDetails(
      title as string
   )
   const { count } = useCampaignPhoneNumberCountStore()

   const isPhoneNumberActive = location.pathname?.includes('/phone-number')
   const isAssistantsActive = location.pathname?.includes('/assistants')
   const isAgentAssignmentActive =
      location.pathname?.includes('/agent-assignment')

   return (
      <div className="flex flex-col w-[260px] shrink-0 border border-white/5 m-3 rounded-lg">
         <div className="px-6 py-5 text-sm font-medium text-white/50">
            Campaign Settings
         </div>

         <div className="flex flex-col">
            <Link
               to={`/campaign/${title}/phone-number?campaignName=${campaignName}`}
               className={`flex items-center justify-between px-6 py-4 border-l-2 transition-colors ${
                  isPhoneNumberActive
                     ? 'border-[#9061DA] bg-[#9061DA]/10'
                     : 'border-transparent hover:bg-white/[0.03]'
               }`}
            >
               <div className="flex items-center gap-x-3">
                  <Icon name="Telephone" className="scale-[0.7] fill-white" />
                  <span className="text-sm font-medium text-white">
                     Phone numbers
                  </span>
               </div>
               <div className="flex items-center gap-x-2">
                  {count > 0 && (
                     <span className="text-xs text-white/50 bg-white/[0.06] px-2 py-0.5 rounded">
                        {count}
                     </span>
                  )}
                  <Icon
                     name="arrow-down"
                     className="scale-75 -rotate-90 fill-white/40"
                  />
               </div>
            </Link>

            <Link
               to={`/campaign/${title}/assistants?campaignName=${campaignName}`}
               className={`flex items-center justify-between px-6 py-4 border-l-2 transition-colors ${
                  isAssistantsActive
                     ? 'border-[#9061DA] bg-[#9061DA]/10'
                     : 'border-transparent hover:bg-white/[0.03]'
               }`}
            >
               <div className="flex items-center gap-x-3">
                  <Icon name="Persona" className="mx-1 fill-white" />
                  <span className="text-sm font-medium text-white">
                     Assistants
                  </span>
               </div>
               <div className="flex items-center gap-x-2">
                  {(LeadSourceDetails?.data?.aiAssistants?.length ?? 0) > 0 && (
                     <span className="text-xs text-white/50 bg-white/[0.06] px-2 py-0.5 rounded">
                        {LeadSourceDetails?.data?.aiAssistants?.length}
                     </span>
                  )}
                  <Icon
                     name="arrow-down"
                     className="scale-75 -rotate-90 fill-white/40"
                  />
               </div>
            </Link>

            <Link
               to={`/campaign/${title}/agent-assignment?campaignName=${campaignName}`}
               className={`flex items-center justify-between px-6 py-4 border-l-2 transition-colors ${
                  isAgentAssignmentActive
                     ? 'border-[#9061DA] bg-[#9061DA]/10'
                     : 'border-transparent hover:bg-white/[0.03]'
               }`}
            >
               <div className="flex items-center gap-x-3">
                  <Icon name="Agent" className="scale-[0.7] fill-white" />
                  <span className="text-sm font-medium text-white">
                     Agent Assignment
                  </span>
               </div>
               <div className="flex items-center gap-x-2">
                  <Icon
                     name="arrow-down"
                     className="scale-75 -rotate-90 fill-white/40"
                  />
               </div>
            </Link>
         </div>
      </div>
   )
}
